export const LearningResourceController = {
    index(): void {},
};
